import type { Competence } from "../Types/Competence";

export const competences: Competence[] = [
  {
    name: "C#",
    description: {
      en: "Professional .NET experience delivering RESTful services and enterprise integrations in production.",
      da: "Professionel .NET-erfaring med levering af RESTful services og enterprise-integrationer i produktion."
    }
  },
  {
    name: "RESTful Applications",
    description: {
      en: "Build and maintain RESTful APIs in .NET Core across multiple production projects. Academic work includes model-based testing of REST APIs",
      da: "Udvikler og vedligeholder RESTful API’er i .NET Core på flere produktionsprojekter. Akademisk arbejde inkluderer modelbaseret test af REST API’er"
    }
  },
  {
    name: "Docker",
    description: {
      en: "Hands-on with containerized dev setups and CI pipelines: multi-container orchestration, custom key-provider injection, scripted setup/teardown.",
      da: "Praktisk erfaring med containeriserede udviklingsmiljøer og CI-pipelines: multi-container orkestrering, custom key-provider injection samt scriptet setup/teardown."
    }
  },
  {
    name: "Frontend",
    description: {
      en: "Production experience with React and Angular: state management, component architecture, form validation, API integration.",
      da: "Produktions­erfaring med Reactand og Angular: state management, komponentarkitektur, formvalidering og API-integration."
    }
  },
  {
    name: "PowerShell",
    description: {
      en: "Automated local environments and multi-step Docker workflows with robust PowerShell scripts (setup, validation, cleanup).",
      da: "Automatiseret lokale miljøer og flertrins Docker-flows med robuste PowerShell-scripts (setup, validering, cleanup)."
    }
  },
  {
    name: "SQL",
    description: {
      en: "Production use of SQL for backend and data access. Former teaching assistant in a university Database Systems course (MySQL).",
      da: "Produktionsbrug af SQL til backend og dataadgang. Tidligere undervisningsassistent på et universitetskursus i databaser (MySQL)."
    }
  },
  {
    name: "Cyber Security",
    description: {
      en: "Completed multiple cybersecurity courses; apply secure coding practices, secrets management, and basic threat modeling in projects.",
      da: "Gennemført flere kurser i cybersikkerhed; anvender secure coding-praksis, håndtering af secrets og grundlæggende threat modeling i projekter."
    }
  },
  {
    name: "Java",
    description: {
      en: "Extensive academic experience in Java, including teaching and mentoring junior students.",
      da: "Omfattende akademisk erfaring med Java, inkl. undervisning og vejledning af juniorstuderende."
    }
  },
  {
    name: "Linux",
    description: {
      en: "Comfortable working in Linux for development, scripting, and server operations.",
      da: "Rutineret i Linux til udvikling, scripting og serverdrift."
    }
  },  
  {
    name: "Scrum",
    description: {
      en: "Served as Scrum Master: facilitated ceremonies, ensured effective planning, reviews, retros, and day-to-day coordination.",
      da: "Fungeret som Scrum Master: faciliteret ceremonier og sikret effektiv planlægning, reviews, retros samt daglig koordinering."
    }
  }
];
